// Typography overrides for the Quicken theme.

import type { Palette } from '@mui/material/styles';

export default function createTypography(palette: Palette) {
  return {
    caption: {
      letterSpacing: 'normal',
      color: palette.text.primary,
    },
    overline: {
      lineHeight: 1.66,
    },
    subtitle1: {
      fontWeight: 500,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      color: palette.text.primary,
    },
  };
}
